import React from 'react'

const SearchInput = ({
  value,
  style,
  placeholder,
  onChange = () => {},
  onKeyDown = () => {},
  id = null,
  inputType = 'textBox',
}) => {
  return (
    <div className={`search-input-container rounded-full`} style={style}>
      <svg
        className="md:w-[19px] md:h-[19px] w-4 h-4"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginRight: 16 }}
      >
        <circle cx="8.65637" cy="9.30712" r="7.52941" stroke="#8B95B1" strokeWidth="1.77778" strokeLinecap="round" />
        <path d="M14.3027 14.9535L17.1263 17.777" stroke="#8B95B1" strokeWidth="1.77778" strokeLinecap="round" />
      </svg>

      {inputType == 'textBox' ? (
        <input
          id={id}
          name="search-val"
          placeholder={placeholder}
          onChange={onChange}
          onKeyDown={onKeyDown}
          value={value ? value : ''}
        />
      ) : (
        <textarea
          id={id}
          name="search-val"
          placeholder={placeholder}
          onChange={onChange}
          onKeyDown={onKeyDown}
          value={value ? value : ''}
        />
      )}
    </div>
  )
}

export default SearchInput
